// extracted by mini-css-extract-plugin
module.exports = {"linksBox":"friendlink-module--linksBox--2kdAP","links":"friendlink-module--links--2DL8x","aBox":"friendlink-module--a-box--1fuLh"};